/* eslint-disable no-nested-ternary */
import styles from "component/landing-page/videoSection.module.scss";
import Image from "next/legacy/image";
import { useState } from "react";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

function VideoWithThumbnail(props) {
  const { className, video, key } = props;
  const { youtubeId } = video;
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  function handleClickPlay() {
    setIsVideoPlaying(true);
  }

  return (
    <div className={`${className} ${styles.video_container}`} key={key}>
      {!isVideoPlaying
        && (
          <>
            <div style={{ position: "absolute" }}>
              <Image
                src={`${video.thumbnailSrc ? getRelativeImagePath(`/cms/${video.thumbnailSrc}`) : `https://i.ytimg.com/vi/${youtubeId}/sddefault.jpg`}`}
                height={400}
                width={370}
                unoptimized
                objectFit="contain"
                loading="lazy"
              />
            </div>
            <div className={`${styles.youtube_thumbnail_mask} ${styles.thumbnail_span} `}>
              <Image
                alt="videoplay"
                src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/common/videoplay.png`}
                onClick={handleClickPlay}
                width={50}
                height={50}
                unoptimized
                loading="lazy"
              />
            </div>
          </>
        )}

      {isVideoPlaying
        && (
          <div className="text-center">

            <iframe
              title="You Tube"
              allowFullScreen
              src={`https://www.youtube.com/embed/${youtubeId}?wmode=transparent&rel=0&showinfo=0&fs=1&autoplay=1`}
              data-clarity-mask="True"
            />
          </div>
        )}

    </div>

  );
}

export default VideoWithThumbnail;
